const SENSITIVE_KEY_PATTERN =
  /(text|transcript|complaint|conduct|patient|name|email|phone|document|cpf|cnpj|summary|answer|question|audio|base64)/i

const SAFE_STRING_VALUE_PATTERN = /^[a-z0-9._:-]+$/i

export const isLangfuseContentEnabled = (): boolean =>
  import.meta.env.VITE_LANGFUSE_ENABLE_CONTENT === 'true'

export const isLangfuseSanitizedMode = (): boolean =>
  import.meta.env.VITE_LANGFUSE_SANITIZED_MODE !== 'false'

const sanitizeStringToken = (value: string): string | null => {
  const clean = value.trim()
  if (!clean || clean.length > 96 || !SAFE_STRING_VALUE_PATTERN.test(clean)) return null
  return clean
}

export const sanitizeLangfuseMetadata = (
  payload: Record<string, unknown> = {},
): Record<string, string | number | boolean | null> => {
  const sanitized: Record<string, string | number | boolean | null> = {}
  Object.entries(payload).forEach(([key, value]) => {
    if (SENSITIVE_KEY_PATTERN.test(key)) return
    if (value == null || typeof value === 'number' || typeof value === 'boolean') {
      sanitized[key] = value == null ? null : value
      return
    }
    if (typeof value === 'string') {
      const token = sanitizeStringToken(value)
      if (token != null) sanitized[key] = token
    }
  })
  return sanitized
}

export const sanitizeLangfuseInputOutput = (
  value: unknown,
): Record<string, unknown> | undefined => {
  if (!isLangfuseContentEnabled() || isLangfuseSanitizedMode()) return undefined
  if (value == null) return undefined
  if (typeof value === 'object' && !Array.isArray(value)) {
    return sanitizeLangfuseMetadata(value as Record<string, unknown>) as Record<string, unknown>
  }
  return undefined
}
